import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Tariff } from '../tariff.model';
import { ActivateSubscriptionModalComponent, ActivateSubscriptionState } from './activate-subscription-modal.component';
import { SupplementComponent } from '../../payment-account/supplement/supplement.component';
import { ModalService } from '../../../core/modal/modal.service';
import { UsersService } from '../../users/user.service';
import { MetricsService } from '../../../shared/metrics/metrics.service';

export interface ActivateSubscriptionModalInputData {
  kkmId: number;
  tariff: Tariff;
}

@UntilDestroy()
@Directive({
  selector: '[taxOpenActivateSubscriptionModal]',
})
export class OpenActivateSubscriptionModalDirective {
  @Input() taxOpenActivateSubscriptionModal?: ActivateSubscriptionModalInputData;

  @Output() subscriptionActivated: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private metricsService: MetricsService,
    private modalService: ModalService,
    private usersService: UsersService,
  ) {
  }

  @HostListener('click')
  openModal(): void {
    this.metricsService.ymGoal('Кнопка "активировать подписку"');

    if (!this.taxOpenActivateSubscriptionModal?.tariff.id) {
      return;
    }

    this.modalService.openOld<ActivateSubscriptionState>(
      ActivateSubscriptionModalComponent,
      {
        kkmId: this.taxOpenActivateSubscriptionModal?.kkmId,
        tariff: this.taxOpenActivateSubscriptionModal?.tariff,
      },
    )
      .pipe(
        untilDestroyed(this),
      )
      .subscribe((result) => {
        if (result === 'notEnoughMoney') {
          this.openSupplementModal();
        } else {
          this.subscriptionActivated.emit();
        }
      });
  }

  private openSupplementModal(): void {
    this.usersService.getCurrentUserInfo()
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.modalService.openOld(
          SupplementComponent,
          {
            billingAccount: user.organisation.billingAccountNumber,
            notification: 'account_payment.modal.not.enough.money',
          },
        );
      });
  }
}
